
import { computed, defineComponent, PropType } from 'vue'

import SLoader from '@/common/components/SLoader/index.vue'

// icons
import iClip from '@/assets/icons/Clip.svg'
import iClose from '@/assets/icons/Close.svg'

export default defineComponent({
    components: { 's-loader': SLoader, iClip, iClose },
    props: {
        value: {
            type: Array as PropType<File[]>,
            default: () => [],
        },
        placeholder: {
            type: String,
            default: 'Прикрепите файл',
        },
        accept: {
            type: String,
            default: '',
        },
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isSmall: {
            type: Boolean,
            default: false,
        },
        isMultiSelect: {
            type: Boolean,
            default: false,
        },
        isInvalid: {
            type: Boolean,
            default: false,
        },
        loadedFilesPlaceholder: {
            type: String,
            default: null,
        },
    },
    emits: ['update:value', 'file-loaded'],
    setup(props, { emit }) {
        const emitUpdate = (event: InputEvent) => {
            const target = event.target as HTMLInputElement
            const files = target.files

            const array_of_files: File[] = []

            if (!files || !files.length) {
                emit('update:value', array_of_files)
                return
            }

            for (let index = 0; index < files.length; index++) {
                const file = files.item(index)
                if (!file) continue
                array_of_files.push(file)
            }

            if (props.isMultiSelect) {
                const value_files = [...props.value]
                emit('update:value', value_files.concat(array_of_files))
            } else {
                emit('update:value', array_of_files)
            }

            target.value = ''
        }

        const resetFiles = () => {
            emit('update:value', [])
        }

        const removeFile = (file_index: number) => {
            const files = [...props.value]
            files.splice(file_index, 1)

            emit('update:value', files)
        }

        //

        const loadedFileTitle = computed(() => {
            if (props.value.length) {
                const placeholder = props.loadedFilesPlaceholder || 'Прикреплено'

                if (props.value.length > 1) {
                    return `${placeholder}: ${props.value.length}`
                }

                return `${placeholder}: ${props.value[0].name}`
            }

            return props.placeholder
        })

        //

        return { emitUpdate, loadedFileTitle, resetFiles, removeFile }
    },
})
